import React, { useContext } from "react";
import useViewport from "utils/hooks/useViewport";

import NavDropdown, {
  DROPDOWN_DIVIDER_ITEM,
} from "components/Layout/Navbar/NavDropdown";
import {
  USER_ACCOUNT_MENU,
  AFFILIATE_MENU,
  USER_ACCOUNT_ACTION_MENU,
  MenuItemList,
} from "components/Layout/Navbar/config";
import { AccountContext } from "contexts/AccountProvider";
import Icon from "@/atoms/Icon";
import { MobileDropdown } from "./MobileNav";

interface MyAccountDropDownProps {
  mobile?: boolean;
  isOpen?: boolean;
  onTriggerClick?: () => void;
}
export const MyAccountDropDown = ({
  mobile = false,
  isOpen = false,
  onTriggerClick,
}: MyAccountDropDownProps) => {
  const { auth } = useContext(AccountContext) as any;
  const { screen } = useViewport();
  const userLinks: MenuItemList = [...USER_ACCOUNT_MENU].concat(
    // Add affiliate links before sign out
    auth?.user?.isAffiliate ? AFFILIATE_MENU : [],
    [DROPDOWN_DIVIDER_ITEM, ...USER_ACCOUNT_ACTION_MENU]
  );

  if (mobile) {
    const item = {
      label: "My Account",
      childLinks: userLinks.filter((item) => item != null),
    };
    return (
      <MobileDropdown
        item={item}
        isOpen={isOpen}
        onTriggerClick={onTriggerClick}
      />
    );
  }

  return (
    <NavDropdown
      label={
        screen === "md" ? <Icon name="user-circle" size="26px" /> : "My Account"
      }
      items={userLinks}
      analyticsLabel="account"
    />
  );
};
